var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { SchedulerApiService } from '../../../../services/scheduler.api.service';
var EventPullingStatusModalComponent = /** @class */ (function (_super) {
    __extends(EventPullingStatusModalComponent, _super);
    function EventPullingStatusModalComponent(fb, accountApiService, alertify, formBuilder, modalService, schedulerApiService, dialogRef) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.formBuilder = formBuilder;
        _this.modalService = modalService;
        _this.schedulerApiService = schedulerApiService;
        _this.dialogRef = dialogRef;
        _this.loading = false;
        _this.eventbrite = [];
        _this.serpGoogle = [];
        return _this;
    }
    EventPullingStatusModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.formBuilder.group({
            googleKey: [null, null],
            blockCategories: [null, null],
        });
        this.loading = true;
        this.schedulerApiService.eventPullingStatus().subscribe(function (data) {
            _this.eventbrite = data.map(function (x) {
                return x.hubName + " - " + new Date(x.eventbrite.lastRunTime).toLocaleString();
            });
            var sortedBySerpGoogle = data.sort(function (a, b) { return a.serpGoogle.lastRunTime - b.serpGoogle.lastRunTime; });
            _this.serpGoogle = sortedBySerpGoogle.map(function (x) {
                return x.hubName + " - " + new Date(x.serpGoogle.lastRunTime).toLocaleString();
            });
            console.log(_this.serpGoogle);
        });
    };
    EventPullingStatusModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return EventPullingStatusModalComponent;
}(BaseComponent));
export { EventPullingStatusModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/event.pulling.status/event.pulling.status.modal.component.ts.pre-build-optimizer.js